import { Check, Clear } from '@mui/icons-material';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { SignatureComponent } from '@syncfusion/ej2-react-inputs';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FileParameter } from '../../../../ApiOld/ApiServerVov';
import DialogBase from '../../../Shared/DialogBase';

interface WarehouseSignatureDialogProps {
    open: boolean;
    stockInOutListSign: boolean;
    onClose: (file: FileParameter | undefined, closeTransaction: boolean) => void;
}

export default function WarehouseSignatureDialog(props: Readonly<WarehouseSignatureDialogProps>) {
    const { open, stockInOutListSign, onClose } = props;
    const [signatureChanged, setSignatureChanged] = React.useState<boolean>(false);
    const theme = useTheme();
    const biggerThan700 = useMediaQuery(theme.breakpoints.up(1100));
    const signRef = useRef<SignatureComponent>(null);
    const { t } = useTranslation();

    return (
        <DialogBase showFullScreenButton marginTop='60px' maxWidth='lg' showCloseButton title={t('log.signature')} open={open} onClose={() => { onClose(undefined, false) }}>
            <Box sx={{ maxHeight: '800px' }}>
                <Box sx={{ margin: '6px', display: 'flex', flexDirection: 'column', border: '1px solid', borderColor: 'lightgray', padding: '8px', borderRadius: '6px' }}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: '13px', margin: '0px 20px' }}>{t('diary.yourSignature')}</Typography>
                    <SignatureComponent change={(e) => {
                        setSignatureChanged(true);
                    }} style={{
                        maxWidth: biggerThan700 ? '410px' : '300px', margin: '12px',
                        backgroundColor: '#F9F9F9'
                    }}
                        ref={signRef}>
                    </SignatureComponent>
                    <Box sx={{ margin: '0px 10px' }}>
                        {!stockInOutListSign && <Button sx={{ width: biggerThan700 ? '156px' : '32px', margin: '4px 12px' }} startIcon={<Clear />} variant='contained' size='small' onClick={(e) => { onClose(undefined, true); }}>{t('warehouses.withoutSignature')}</Button>}
                        <Button sx={{ width: biggerThan700 ? '186px' : '32px', margin: '4px 12px' }} disabled={!signatureChanged} startIcon={<Check />} color='success' variant='contained' size='small' onClick={(e) => {
                            setSignatureChanged(false);
                            const blob = signRef.current!.saveAsBlob();
                            const fileParameter: FileParameter = { data: blob, fileName: 'sign.png' };
                            onClose(fileParameter, true);
                        }}>{biggerThan700 && t('employee.saveSignature')}</Button>
                    </Box>
                </Box>
            </Box>
        </DialogBase>
    );
}